import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "../../web/src/index.css"
import App from "@/App"
import { initPostHog, registerGlobalErrorHandlers } from "@/lib/posthog"

initPostHog()
registerGlobalErrorHandlers()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
